/**
 * Don't modify this file, only override build functions to the things you want to change
 * Filter is using the TFilterTemplate, by calling TFilterTemplate.main.build(data)
 * with the object from config json, to build the html as a string, and returns it.
 */

var TFilterTemplate = {
    elements: {
        label: {
            build (data)
            {
                var el = data.data.find(function (itm) { return itm.selected; });
                var value = el ? el.label : data.placeholder;
                return `
                    <span class="filter-label-type">${data.title}</span>
                    <span class="filter-label-value">${value}</span>
                `;
            }
        },
        input: {
            build (data)
            {
                var el = data.data.find(function (itm) { return itm.selected; }) || (data.data.length === 1 && data.data[0]);
                var value = (el && el.label !== data.placeholder) ? data.title + el.label : "";
                var label = data.title ? ` data-label="${data.title}"` : "";
                return `<input type="text" id="filter_value_${data.id}" class="filter-input-value" placeholder="${data.placeholder}" value="${value}" data-select="${data.id}" data-select-action="oninput"${label} readonly>`;
            }
        },
        radio: {
            build (data, id)
            {
                var checked = data.selected ? "checked" : "";
                return `
                    <span class="filter-radio-item"><!-- same group as in the carousel, only content inside <label> differs -->
                        <input id="item_id_${id + data.value}" class="filter-radio-input" ${checked} type="radio" name="${id}" value="${data.value}">
                        <label for="item_id_${id + data.value}" class="filter-radio-label">${data.label}</label>
                    </span>
                `;
            }
        },
        carousel: {
            build (data, id)
            {
                var checked = data.selected ? "checked" : "",
                    disabled = data.disabled ? "disabled" : ""
                return `
                    <span class="filter-carousel-item">
                        <input id="item_id_${id + data.value}" class="filter-carousel-input" ${checked} ${disabled} type="radio" name="${id}" value="${data.value}">
                        <label for="item_id_${id + data.value}" class="filter-carousel-label">${data.label}</label>
                    </span>
                `;
            }
        },
        action: {
            build (className, action)
            {
                return `<span clickAction="${action}" class="filter-action ${className}">_</span>`;
            }
        },
        option: {
            build (data)
            {
                // some labels will come with HTML, we need to clear them up
                var label = data.label || "";
                var sanitizedLabel = (label.replace(/<\/?[^>]+(>|$)/g, " ").match(/(\S+)/g) || []).join(" ");
                var selected = data.selected ? " selected" : "";
                var disabled = data.disabled ? " disabled" : "";
                var odds = data.odds ? ` odds="${data.odds}"` : ""; // odds attribute is used in buy points selects
                return `<option${selected + disabled + odds} value="${data.value}">${sanitizedLabel}</option>`;
            }
        },
        htmloption: {
            build (data)
            {
                var selected = data.selected ? "filter-htmldropdown-option-selected" : "";
                return `
                    <span data-value="${data.value}" clickAction="changeHTMLDropdown" class="filter-htmldropdown-option ${selected} ">${data.label}</span>
                    <span class="filter-htmldropdown-option-spacer"></span>
                `;
            }
        },
        customselectoption: {
            build (data, id)
            {
                if (data.disabled) { return ""; }
                var selected = data.selected ? "filter-htmldropdown-option-selected" : "";
                return `
                    <span class="filter-htmldropdown-option ${selected}" data-value="${data.value}" data-select="${id}" data-select-action="onoption">${data.label}</span>
                    <span class="filter-htmldropdown-option-spacer"></span>
                `;
            }
        },
        checkbox: {
            build (data, id)
            {
                var checked = data.selected ? "checked" : "";
                return `
                    <span class="filter-checkbox-item"><!-- same group as in the carousel, only content inside <label> differs -->
                        <input id="item_id_${id + data.value}" class="filter-checkbox-input" ${checked} type="checkbox" name="${id}" value="${data.value}">
                        <label for="item_id_${id + data.value}" class="filter-checkbox-label">${data.label}</label>
                    </span>
                `;
            }
        },
        customTab:
        {
            build (data)
            {
                var activeTabCssClass = data.selected ? "user-info__tab--active" : "";
                var disabledCssClass = data.isDisabled ? "disabled" : "";

                return `
                    <div clickAction="changeSwitchFilter" id="${data.tabID}" class="user-info__tab ${activeTabCssClass + disabledCssClass}" data-value="${data.value}">
                        ${data.tooltip}
                    </div>
                `;
            }

        }
    },
    blocks: {
        label: {
            build (data)
            {
                var htmlCustomArrow = data.hasOnlyOneOption ? "" : "<span class=\"filter-label-trigger arrow-custom-down\"></span>";
                return `
                    <label for="item_id_${data.id}" class="filter-label ${addCustomClass("disabled", data.disabled)}" >
                        <span class="filter-label-wrapper">
                            ${TFilterTemplate.elements.label.build(data)}
                        </span>
                        ${htmlCustomArrow}
                    </label>
                `;
            }
        },
        input: {
            build (data)
            {
                var dataUat = data.uat ? ` data-uat="${data.uat}-label"` : "";
                return `
                    <label for="filter_value_${data.id}" class="filter-label"${dataUat}>
                        <span class="filter-label-wrapper">${TFilterTemplate.elements.input.build(data)}</span>
                        <span class="filter-label-trigger arrow-custom-down"></span>
                    </label>
                `;
            }
        },
        radio: {
            build (data)
            {
                var _html = `
                    <!-- implementation for bigger screens -->
                    <div class="filter-radio-block"><!-- fixed size on the screen, scrolls -->
                        <div class="filter-radio-wrapper"><!-- holds all the options -->`;
                            var arr = data.data, l = arr.length;
                            for (var i = 0; i < l; i += 1) {
                                _html += TFilterTemplate.elements.radio.build(arr[i], data.id);
                            } _html += `
                        </div>
                    </div>`;
                return _html;
            }
        },
        carousel: {
            build (data)
            {
                var _html = `
                    <!-- implementation for bigger screens -->
                    <div class="filter-carousel-block"><!-- fixed size on the screen, scrolls -->
                        <div data-scroll="0" class="filter-carousel-wrapper"><!-- holds all the options -->`;
                            var arr = data.data,
                            l = arr.length;
                            for (var i = 0; i < l; i += 1) {
                                _html += TFilterTemplate.elements.carousel.build(arr[i], data.id);
                            } _html += `
                        </div>
                    </div>`;
                return _html;
            }
        },
        action: {
            build (data)
            {
                return `
                    <div class="filter-actions"> <!-- generic actions container -->
                        ${TFilterTemplate.elements.action.build("filter-action-left filter-action-inactive", "carouselRight")}
                        ${TFilterTemplate.elements.action.build("filter-action-right", "carouselLeft")}
                    </div>
                `;
            }
        },
        select: {
            build (data, custom?)
            {
                var dataSelect = custom ? ` data-select="${data.id}"` : "";
                var dataUat = data.uat ? ` data-uat="${data.uat}"` : "";
                var nameAttr = custom ? data.name : data.id;
                var onChangeAttr = data.inlineHandler ? " onchange=" + data.inlineHandler : "";
                var additionalClasses = data.selectClass ? " " + data.selectClass : "";
                var _html = `
                    <select changeAction="updateLabel" class="filter-selectbox${additionalClasses}" id="${data.id}" name="${nameAttr}"${(data.disabled ? " disabled" : "") + dataSelect + onChangeAttr + dataUat}>`;
                        var arr = data.data, l = arr.length;
                        for (var i = 0; i < l; i += 1)
                        {
                            // The value of the heading option ( the one that can not be selected ) is -1
                            if (arr[i].value === "-1")
                            {
                                arr[i].disabled = true;
                            }
                            _html += TFilterTemplate.elements.option.build(arr[i]);
                        } _html += `
                    </select>`;
                return _html;
            }
        },
        htmldropdown: {
            build (data)
            {
                var disabled = data.disabled ? "disabled" : "";
                var _html = `
                    <div data-id="${data.id}" clickAction="triggerHTMLDropdown" class="filter-htmldropdown-placeholder ${disabled}"></div>
                    <div class="filter-htmldropdown-wrapper scrollable" name="${data.id}" id="${data.id}">
                        <div class="scrollable-wrapper">
                            <input type="hidden" name="${data.id}" value=""/>`;
                            var arr = data.data, l = arr.length;
                            for (var i = 0; i < l; i += 1)
                            {
                                _html += TFilterTemplate.elements.htmloption.build(arr[i]);
                            } _html += `
                        </div>
                    </div>`;
                return _html;
            }
        },
        customselect: {
            build (data)
            {
                var _html = `
                    <div class="filter-htmldropdown-wrapper scrollable" id="scrollable_${data.id}">
                        <div class="scrollable-wrapper">
                            <input type="hidden" name="filter_hidden_${data.id}" value=""/>`;
                            var arr = data.data, l = arr.length;
                            for (var i = 0; i < l; i += 1)
                            {
                                if (l === 1 && !data.placeholder)
                                {
                                    arr[i].selected = true;
                                }
                                _html += TFilterTemplate.elements.customselectoption.build(arr[i], data.id);
                            } _html += `
                        </div>
                    </div>`;
                return _html;
            }
        },
        checkbox: {
            build (data)
            {
                var _html = `
                    <div class="filter-checkbox-block"><!-- fixed size on the screen, scrolls -->
                        <div class="filter-checkbox-wrapper"><!-- holds all the options -->`;
                            var arr = data.data, l = arr.length;
                            for (var i = 0; i < l; i += 1)
                            {
                                _html += TFilterTemplate.elements.checkbox.build(arr[i], data.id);
                            } _html += `
                        </div>
                    </div>`;
                return _html;
            }
        }
    },
    layouts: {
        htmldropdown: {
            build (data)
            {
                var customClasses = [data.hideSelectedOption ? "isSelectedHidden" : "", data.isDropDownSelected ? "filter-htmldropdown-active" : ""];
                var _html = `
                    <!-- dropdown filter markup -->
                    <div class="filter-component filter-htmldropdown"><!-- dropdown BEGINS -->
                        <div id="filter-component-${data.id}" class="filter-component-wrapper ${customClasses.join(" ")}" data-uat="filter-dropdown">
                            ${TFilterTemplate.blocks.label.build(data)}`;
                            if (!data.hasOnlyOneOption)
                            {
                                _html += TFilterTemplate.blocks.htmldropdown.build(data);
                                _html += TFilterTemplate.blocks.select.build(data);
                            } _html += `
                        </div>
                    </div><!-- dropdown ENDS -->`;
                return _html;
            }
        },
        customselect: {
            build (data)
            {
                return `
                    <div class="filter-customselect">
                        <div class="filter-customselect-wrapper">
                            ${TFilterTemplate.blocks.input.build(data)}
                            ${TFilterTemplate.blocks.customselect.build(data)}
                            ${TFilterTemplate.blocks.select.build(data, true)}
                        </div>
                    </div>
                `;
            }
        },
        dropdown: {
            build (data)
            {
                return `
                    <!-- dropdown filter markup -->
                    <div class="filter-component filter-dropdown"><!-- dropdown BEGINS -->
                        <div id="filter-component-${data.id}" class="filter-component-wrapper" data-uat="filter-dropdown">
                            ${TFilterTemplate.blocks.label.build(data)}
                            ${TFilterTemplate.blocks.select.build(data)}
                        </div>
                    </div><!-- dropdown ENDS -->
                `;
            }
        },
        radio: {
            build (data)
            {
                return `
                    <!-- radio filter markup -->
                    <div class="filter-component filter-radio"><!-- radio BEGINS -->
                        <div id="filter-component-${data.id}" class="filter-component-wrapper">
                            ${TFilterTemplate.blocks.label.build(data)}
                            ${TFilterTemplate.blocks.radio.build(data)}
                            ${TFilterTemplate.blocks.select.build(data)}
                        </div>
                    </div><!-- radio ENDS -->
                `;
            }
        },
        carousel: {
            build (data)
            {
                return `
                    <!-- carousel filter markup -->
                    <div class="filter-component filter-carousel"><!-- carousel BEGINS -->
                        <div id="filter-component-${data.id}" class="filter-component-wrapper">
                            ${TFilterTemplate.blocks.label.build(data)}
                            ${TFilterTemplate.blocks.carousel.build(data)}
                            ${TFilterTemplate.blocks.action.build(data)}
                            ${TFilterTemplate.blocks.select.build(data)}
                        </div>
                    </div><!-- carousel ENDS -->
                `;
            }
        },
        checkbox:
        {
            build (data)
            {
                return `
                    <!-- checkbox filter markup -->
                    <div class="filter-component filter-checkbox"><!-- checkbox BEGINS -->
                        <div id="filter-component-${data.id}" class="filter-component-wrapper">
                            ${TFilterTemplate.blocks.label.build(data)}
                            ${TFilterTemplate.blocks.checkbox.build(data)}
                        </div>
                    </div><!-- checkbox ENDS -->
                `;
            }
        },
        toggleOnOffFilter:
        {
            build (data)
            {
                var val = data.data[0].selected ? 1 : 0, checked = data.data[0].selected ? "" : "checked";
                return `
                    <div id="filter-component-${data.id}" class="filter-component-wrapper ${data.className}">
                        <span class="switch">
                            <input ${checked} changeAction="updateSwitchButton" type="checkbox" name="${data.id}" id="${data.id}" class="switch__check hidden" value="${val}" data-uat="show-only-cashout-bets">
                            <label class="switch__label" for="${data.id}">
                                <span class="switch__roll">
                                    <span class="switch__text switch--on">${data.data[0].tooltip}</span>
                                    <span class="switch__knob"></span>
                                    <span class="switch__text switch--off">${data.data[1].tooltip}</span>
                                </span>
                            </label>
                        </span>
                        <label class="switchLabel" for="${data.id}">${data.title}</label>
                    </div>
                `;
            }
        },
        switchFilter:
        {
            build (data)
            {
                var _html = `
                    <div id="filter-component-${data.id}" class="filter-component-wrapper">
                        <input type="hidden" id="${data.id}" value="${data.selectItemID}"/>
                        <label class="filter-component-label user-info__tabs" for="${data.id}">`;
                            var filterOptions = data.data,
                                filterOptionsLength = filterOptions.length;
                            for (var i = 0; i < filterOptionsLength; i += 1) {
                                _html += TFilterTemplate.elements.customTab.build(filterOptions[i]);
                            } _html += `
                            <div class="user-info-tab-switch-overlay"></div>
                        </label>
                    </div>`;
                return _html;
            }
        }
    },

    main: {
        // do NOT use this method outside, it's not part of the interface
        buildContent (data)
        {
            var _html = `
                <div class="filter-wrapper"><!-- filter wrapper BEGINS -->`;
                    var filters = data.filters, i = 0, l = filters.length, filter, layout;
                    for (i = 0; i < l; i += 1)
                    {
                        filter = filters[i];
                        layout = TFilterTemplate.layouts[filter.type];
                        _html += layout ? layout.build(filter) : "";
                    } _html += `
                </div><!-- filter wrapper ENDS -->`;
            return _html;
        },
        build (data)
        {
            var additionalClasses = data.cssClasses ? " " + data.cssClasses : "";
            return `
                <div id="${data.id}" class="filter filter-container${additionalClasses} "><!-- filter BEGINS -->
                    ${this.buildContent(data)}
                </div><!-- filter ENDS -->
            `;
        }
    },
    custom: {
        /**
         * @params {Object} data {
         *   id: string;
         *   disabled?: boolean;
         *   cssClasses?: string;
         *   selectClass?: string;
         *   placeholder?: string;
         *   title?: string;
         *   data: Object[] {
         *     label: string;
         *     value: string|number;
         *     selected: boolean;
         *     disabled: boolean;
         *   };
         *   inlineHandler?: string;
         * }
         */
        build (data) {
            var additionalClasses = data.cssClasses ? " " + data.cssClasses : "";
            var disabled = data.disabled ? " filter-disabled" : "";
            return `
                <div id="filter_${data.id}" class="filter filter-custom${additionalClasses + disabled}">
                    <div class="filter-wrapper">
                        ${TFilterTemplate.layouts.customselect.build(data)}
                    </div>
                </div>
            `;
        }
    }
};

jsRequire("/JSComponents/Filter/TFilterTemplate.ext.js");